import { render } from "./SectionTable.vue?vue&type=template&id=79674d8b"
import script from "./SectionTable.vue?vue&type=script&lang=js"
export * from "./SectionTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__